import { staticText as portuguesstaticText } from './pt/index';
import { staticText as englishStaticTexts } from './en/index';
import { staticText as espanholStaticText } from './esp/index';

const staticText = {
  ...portuguesstaticText,
  ...englishStaticTexts,
  ...espanholStaticText
}

// console.log('MAIN', staticText)
export { staticText }